import type { FC } from 'react';

export type ErrorMessageProps = {
  message: string | undefined;
  show: boolean;
  id?: string;
};

/**
 * Accessible error message display for datepicker validation.
 */
export const ErrorMessage: FC<ErrorMessageProps> = ({ message, show, id }) => {
  if (!show || !message) {
    return null;
  }

  return (
    <div
      id={id}
      role="alert"
      aria-live="polite"
      className="border-color-ref-ui-status-danger mt-1 text-sm"
    >
      {message}
    </div>
  );
};
